import React from "react";

/**
 * Site-wide minimal footer used across every screen.
 * Two variants: dark (default, matches landing/dashboard tone) and light.
 */
export function AppFooter({ variant = "dark", compact = false }) {
  const dark = variant === "dark";
  const baseCls = dark
    ? "bg-[#0A0C10] text-neutral-400 border-t border-white/10"
    : "bg-[#F8F9FA] text-neutral-500 border-t border-neutral-200";
  return (
    <footer data-testid="app-footer" className={`${baseCls} mt-auto`}>
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${compact ? "py-3" : "py-4"} flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] sm:text-xs font-mono uppercase tracking-[0.16em]`}>
        <div className="inline-flex items-center gap-2">
          <span>© 2026 TeachingSoftware.ai</span>
          <span className={dark ? "text-neutral-700" : "text-neutral-300"}>·</span>
          <span>A <a
            href="https://www.cloudlabweb.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cloudlab-link"
            className={`underline underline-offset-4 decoration-[#FFD600]/60 hover:text-[#FFD600] transition-colors`}
          >Cloud Lab Technologies</a> product</span>
          <span className={dark ? "text-neutral-700" : "text-neutral-300"}>·</span>
          <span>UK</span>
        </div>
        <div className={`inline-flex items-center gap-2 ${dark ? "text-neutral-600" : "text-neutral-400"}`}>
          <span className="w-1.5 h-1.5 bg-[#FFD600] inline-block" />
          <span>The AI Teaching OS</span>
        </div>
      </div>
    </footer>
  );
}
